export const globalMouseHelper = (event) => {
  window.mouseY = event.screenX;
  window.mouseY = event.screenY;
};
